import { render } from "./Button.vue?vue&type=template&id=01a2f1d6&scoped=true&ts=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=01a2f1d6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a2f1d6"]])

export default __exports__